import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'gdpr-disable-modal',
	template: require('./gdpr-disable-modal.html'),
	styles: [require('./gdpr-disable-modal.scss')]
})
export class GdprDisableModalComponent {
	constructor(private activeModal: NgbActiveModal) {}

	closeModal(state): void {
		this.activeModal.close(state);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/brands/modals/gdpr-disable-modal/gdpr-disable-modal.ts